// extracted by mini-css-extract-plugin
export default {"wrapper":"unloadingTables_wrapper__YY7kn"};